<ion-header>
  <ion-toolbar color="primary">
    <!-- <ion-icon slot="start" size="large" class="header-icon" [src]="TP_SECTIONS_INFO['icd9'].icon | getIcon"></ion-icon> -->
    <ion-title class="header-title">Informazioni</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="onCancel()">Chiudi</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<div class="content-container">
  <!-- Mostra testo se presente -->
  <div *ngIf="formattedText; else noMatch" class="assistant-text-container">
    <p class="assistant-text" [innerHTML]="formattedText"></p>
  </div>

  <!-- Blocco alternativo -->
  <ng-template #noMatch>
    <div class="assistant-text-container no-match">
      <p>Nessuna corrispondenza trovata.</p>
    </div>
  </ng-template>
</div>

<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button color="medium" (click)="onCancel()">
        Ok
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>